import React, { lazy, Suspense, useMemo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useParams, useNavigate } from 'react-router-dom';

const TtdList = lazy(() => import('./TtdList.jsx'));
const TtdCalendar = lazy(() => import('./TtdCalendar.jsx'));

const allTabs = [
  {
    label: 'TTD Calendar Approved',
    value: 'approved-list',
    component: <TtdCalendar />,
    skeletonType: 'table',
  },
  {
    label: 'TTD Records',
    value: 'list',
    component: <TtdList />,
    skeletonType: 'table',
  },
];

const ViewTtd = () => {
  const { tab } = useParams();
  const navigate = useNavigate();

  const tabConfig = useMemo(() => {
    return allTabs;
  }, []);

  const activeTabIndex = useMemo(() => {
    const index = tabConfig.findIndex((t) => t.value === tab);
    return index !== -1 ? index : 0;
  }, [tab, tabConfig]);

  const handleTabChange = (event, newIndex) => {
    navigate(`/ttd-calendar/${tabConfig[newIndex].value}`);
  };

  return (
    <div className="p-4">
      <Box className="border-b border-gray-200 mb-4">
        <Tabs
          value={activeTabIndex}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          textColor="inherit"
          indicatorColor="secondary"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#063f5b',
            },
          }}
        >
          {tabConfig.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                color: activeTabIndex === index ? '#063f5b' : '#1f2937',
                fontWeight: activeTabIndex === index ? '600' : '800',
              }}
            />
          ))}
        </Tabs>
      </Box>

      <div className="bg-white rounded-xl shadow p-4 min-h-[300px]">
        <Suspense fallback={<div className="animate-pulse">Loading...</div>}>
          <Fade in timeout={300}>
            <div>{tabConfig[activeTabIndex].component}</div>
          </Fade>
        </Suspense>
      </div>
    </div>
  );
};

export default ViewTtd;
